import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ShieldX } from "lucide-react";

export default function RoleRoute({ roles, perm, children }) {
  const { user, can } = useAuth();

  if (user === null) {
    return (
      <div className="flex-1 flex items-center justify-center bg-slate-50 min-h-[60vh]">
        <div className="h-8 w-8 border-2 border-slate-300 border-t-blue-500 rounded-full animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;

  const roleAllowed = !roles || roles.includes(user.role);
  const permAllowed = !perm || can(perm);
  if (!roleAllowed || !permAllowed) {
    return (
      <div
        data-testid="role-forbidden"
        className="flex-1 flex items-center justify-center bg-slate-50 min-h-[60vh] px-6"
      >
        <div className="max-w-md text-center">
          <div className="h-14 w-14 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mx-auto mb-4">
            <ShieldX className="h-7 w-7 text-red-500" />
          </div>
          <div className="text-[18px] font-bold text-slate-900 mb-1.5">Access denied</div>
          <p className="text-[13.5px] text-slate-500 leading-relaxed">
            You don&apos;t have permission to view this area. Contact your administrator if you need access.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
